<template lang="pug">
div
  v-card.border.rounded-lg.pa-6(outlined min-height="100vh")
    v-row(dense align="center")
      v-col(cols="5")
        div.text-sm.font-semibold.neutral700--text Activities
      v-col(cols="7")
        y-select(v-model="offer" small placeholder="Select campaign" attach :items="offers" item-text="name" item-value="id" :loading="isFetchingOffers" @change="fetchActivities")
    div.mt-3
      div.d-flex.justify-center.mt-16(v-if="isFetching")
        v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
      template(v-else)
        div.py-3(v-for="activity in activities")
          div.text-xs.neutral700--text
            span.font-medium.mr-1 {{ activity.name }}
            | redeemed {{ activity.coupon.code }} code
          div.d-flex.align-center.mt-2
            v-avatar.mr-2(size="3" color="blue500")
            div.text-xs.neutral500--text {{ activity.redeemed_at | convertToHumanizeTime }}
        div.py-3(v-if="!activities.length")
          div.text-xs.neutral500--text.font-medium.text-center.mt-6 No data

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      isFetching: false,
      isFetchingOffers: false,
      offer: null,
      activities: [],
      offers: [{ id: null, name: 'All campaigns' }],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  mounted () {
    this.fetchOffers()
    this.fetchActivities()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchOffers () {
      this.isFetchingOffers = true
      let params = {
        types: 'campaign,preset',
        fields: 'id,name',
        page_size: -1
      }
      this.$axios.get(`/marketing/${this.company.slug}/offers`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            let offers = resp.data.results
            offers.unshift({ id: null, name: 'All campaigns' })
            this.offers = offers
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingOffers = false
        })
    },
    fetchActivities () {
      this.isFetching = true
      let params = {
        ordering: 'redeemed_at',
        offer_types: 'campaign,preset',
      }
      if (this.offer) {
        params.offers = this.offer
      }
      this.$axios.get(`/marketing/${this.company.slug}/redeems`, { params })
        .then(resp => {
          this.activities = resp.data.results
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>